import { Box, Button, Icon, IconButton, Stack, Tab, Tabs } from "@mui/material";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AdProjectPhotoDto } from "../../../api/psc";
import { DialogContainer } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import AdProjectDetailLocation from "../components/AdProjectDetailLocation";
import AdProjectDetailPhotos from "../components/AdProjectDetailPhotos";

enum ViewType {
    Photos = 1,
    Location = 2,
}

export default function AdProjectDetail(props: { item: AdProjectPhotoDto }) {
    const { closeDialog } = useContext(DialogContext);

    const [viewType, setViewType] = useState(ViewType.Photos);

    const handleViewTypeChange = (
        event: React.SyntheticEvent,
        type: ViewType
    ) => {
        setViewType(type);
    };

    return (
        <DialogContainer preferredWith={850}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Tabs value={viewType} onChange={handleViewTypeChange}>
                    <Tab value={ViewType.Photos} label="تصاویر" />
                    <Tab value={ViewType.Location} label="نقشه" />
                </Tabs>

                <Box flexGrow={1} />

                <Link
                    target="_blank"
                    to={`/project/${props.item.projectHashId}`}
                >
                    <Button variant="outlined" size="small">
                        لینک پروژه
                    </Button>
                </Link>

                <IconButton onClick={closeDialog}>
                    <Icon>close</Icon>
                </IconButton>

                <Box />
            </Stack>

            {viewType === ViewType.Photos && (
                <AdProjectDetailPhotos item={props.item} />
            )}

            {viewType === ViewType.Location && (
                <AdProjectDetailLocation item={props.item} />
            )}
        </DialogContainer>
    );
}
